import { isProductKey, type ProductKey } from '@traceio-org/platform-contracts';

/**
 * The product a sign-in in this tab is for, kept across the Auth0 redirect so the callback page and the boot
 * screen can show "Signing you in to <product>" from their first frame instead of a generic title that then
 * changes. Presentation only: nothing reads it to decide access, and an unknown value is ignored.
 */
const SIGNING_IN_PRODUCT_KEY = 'trace.hub.signingInProduct';

export function rememberSigningInProduct(productKey: ProductKey | null | undefined): void {
  try {
    if (productKey) window.sessionStorage.setItem(SIGNING_IN_PRODUCT_KEY, productKey);
    else window.sessionStorage.removeItem(SIGNING_IN_PRODUCT_KEY);
  } catch {
    // Storage blocked: the screens fall back to the generic title.
  }
}

export function signingInProduct(): ProductKey | null {
  try {
    const value = window.sessionStorage.getItem(SIGNING_IN_PRODUCT_KEY);
    return isProductKey(value) ? value : null;
  } catch {
    return null;
  }
}
